const ORDER_STATUS_IN_EMAIL_LABELS: Record<string, string> = {
  pending_seller: "Awaiting Seller",
  seller_confirmed: "Seller Confirmed",
  confirmed: "Confirmed",
  shipped: "Shipped",
  delivered: "Delivered",
  delivery_reclassified: "Delivery Updated",
  delivery_complete: "Delivery Complete",
  etickets_finalized: "E-Tickets Ready",
  shipment_delivered: "Shipment Delivered",
  shipment_complete: "Shipment Complete",
  completed: "Completed",
  cancelled: "Cancelled",
  canceled: "Cancelled",
  refunded: "Refunded",
  te_failed: "Event Unavailable",
  pending: "Pending Seller Confirmation",
};

const toTitleCase = (value: string) =>
  value
    .replace(/[_-]+/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

export const formatOrderStatusInEmail = (status: string | null | undefined): string => {
  if (!status) return "-";
  const normalized = status.trim().toLowerCase();
  if (!normalized) return "-";
  return ORDER_STATUS_IN_EMAIL_LABELS[normalized] ?? toTitleCase(normalized);
};
